import * as Actions from 'store/actions/app/treasury_movement_types.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_treasury_movement_types: false,
  treasury_movement_types: [],

  saving_treasury_movement_type: false,
  saved_treasury_movement_type: false,
  saved_treasury_movement_type_data: null,

  voiding_treasury_movement_type_ids: [],
  voided_treasury_movement_type_ids: [],
}

export default function treasuryMovementTypesReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_TREASURY_MOVEMENT_TYPES: {
      return {
        ...state,
        loading_treasury_movement_types: action.payload.loading,
        treasury_movement_types: action.payload.data ?? state.treasury_movement_types,
      }
    }
    case Actions.SAVE_TREASURY_MOVEMENT_TYPE: {
      return {
        ...state,
        saving_treasury_movement_type: action.payload.saving ?? state.saving_treasury_movement_type,
        saved_treasury_movement_type: action.payload.saved ?? false,
        saved_treasury_movement_type_data: action.payload.data ?? null,
        treasury_movement_types: action.payload.data
          ? addOrUpdateObjectInArray(state.treasury_movement_types, action.payload.data, 'tipo_movimiento_tesoreria_id', true)
          : state.treasury_movement_types,
      }
    }
    case Actions.VOID_TREASURY_MOVEMENT_TYPE: {
      return {
        ...state,
        voiding_treasury_movement_type_ids: toggleIdInArray(state.voiding_treasury_movement_type_ids, action.payload.voiding_id),
        voided_treasury_movement_type_ids: toggleIdInArray(state.voided_treasury_movement_type_ids, action.payload.voided_id),
        treasury_movement_types: state.treasury_movement_types.filter(item => item.tipo_movimiento_tesoreria_id !== action.payload.voided_id)
      }
    }
    default: {
      return state
    }
  }
}
